<div [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start start">
	<div class="function">
		<p>
			This tool will allow an admin to view the site from the point of view of a selected school or year.
			This will only affect your viewing of the site and will reset when you log off.
		</p>
		<mat-toolbar color="primary">
			<span>School Selection</span>
		</mat-toolbar>
		<section class="mat-elevation-z12 padded">
			<h2 class="mat-headline primarycolor500">
				Current School:&nbsp;
				<span *ngIf="CurrentSchool">{{CurrentSchool.SchoolName}} <span *ngIf="CurrentSchool.InSchoolGroup">({{CurrentSchool?.SchoolNumberList}})</span><span *ngIf="!CurrentSchool.InSchoolGroup">({{CurrentSchool?.SchoolNumber}})</span></span>
				<span *ngIf="!CurrentSchool">None Selected</span>
			</h2>
			<div class="margin-bottom" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
				<strong>Available Schools:</strong>
				<mat-form-field appearance="outline" fxFlex.gt-sm="50">
					<mat-select matInput [(ngModel)]="TentativeSchool" aria-label="School selection list" placeholder="Select school...">
						<mat-option [value]="null">Select school...</mat-option>
						<mat-option *ngFor="let sch of AvailableSchools" [value]="sch">
							<span>{{sch.SchoolName}} </span>
							<span *ngIf="sch.InSchoolGroup">({{sch.SchoolNumberList}})</span>
							<span *ngIf="!sch.InSchoolGroup">({{sch.SchoolNumber}})</span>
						</mat-option>
					</mat-select>
				</mat-form-field>
				<button type="button" mat-raised-button color="primary" (click)="SetCurrentSchool()" [disabled]="!TentativeSchool">Update Current School</button>
			</div>
		</section>
	</div>

	<div class="function">
		<mat-toolbar color="primary">Year Selection</mat-toolbar>
		<section class="mat-elevation-z12 padded">
			<h2 class="mat-headline primarycolor500">Current School Year:&nbsp;<span>{{CurrentSchoolYear | schoolYear}}</span></h2>
			<div class="margin-bottom" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
				<strong>Available Years:</strong>
				<mat-form-field appearance="outline" fxFlex.gt-sm="50">
					<mat-select matInput [(ngModel)]="TentativeYear" aria-label="Year selection list" placeholder="Select year...">
						<mat-option [value]="null">Select year...</mat-option>
						<mat-option *ngFor="let yr of AvailableYears" [value]="yr">{{yr | schoolYear}}</mat-option>
					</mat-select>
				</mat-form-field>
				<button type="button" mat-raised-button color="primary" (click)="SetCurrentSchoolYear()" [disabled]="!TentativeYear">Update Current Year</button>
			</div>
		</section>
	</div>
</div>